import { render, staticRenderFns } from "./IvDiagram.vue?vue&type=template&id=3d45e120&scoped=true&"
import script from "./IvDiagram.vue?vue&type=script&lang=js&"
export * from "./IvDiagram.vue?vue&type=script&lang=js&"
import style0 from "./IvDiagram.vue?vue&type=style&index=0&id=3d45e120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45e120",
  null
  
)

export default component.exports